import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl + 'academy';

@Injectable({
  providedIn: 'root'
})
export class AcademyprofileService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) { 
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      Headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }

getacademydetails(id) : Observable<any>{
  return this.http.get(API_URL + '/' + id, this.httpOptions);
}

updateAcademy(id, data): Observable<any> {
  return this.http.put(API_URL + '/' + id, data, this.httpOptions);
}
}
